import config from 'config';
import authHeader from '../helpers/authHeaders';

export const promotionService = {
  getSettings,
  updateSettings,
  getCodes,
  issueCode,
  revokeCode,
  resendCode,
};

function getQueryString(params) {
  const esc = encodeURIComponent;
  return Object.keys(params)
    .filter(k => params[k] != null && params[k] !== '')
    .map(k => esc(k) + '=' + esc(params[k]))
    .join('&');
}

function getSettings() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };
  return fetch(`${config.apiUrl}/promotions/settings`, requestOptions).then(handleResponse);
}

function updateSettings(data) {
  const requestOptions = {
    method: 'PUT',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  };
  return fetch(`${config.apiUrl}/promotions/settings`, requestOptions).then(handleResponse);
}

function getCodes(criteria) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };
  const qs = criteria && Object.keys(criteria).length ? `?${getQueryString(criteria)}` : '';
  return fetch(`${config.apiUrl}/promotions/codes${qs}`, requestOptions).then(handleResponse);
}

function issueCode(email) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  };
  return fetch(`${config.apiUrl}/promotions/codes`, requestOptions).then(handleResponse);
}

function revokeCode(id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
  };
  return fetch(`${config.apiUrl}/promotions/codes/${id}/revoke`, requestOptions).then(handleResponse);
}

function resendCode(id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
  };
  return fetch(`${config.apiUrl}/promotions/codes/${id}/resend`, requestOptions).then(handleResponse);
}

function logout() {
  // remove user from local storage to log user out
  localStorage.removeItem('token');
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text ? safeParse(text) : {};
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        logout();
        window.location.reload(true);
      }
      // Error bodies from the promotions API are plain text, not JSON.
      const error = { status: response.status, ...(typeof data === 'object' ? data : { error: data }) };
      return Promise.reject(error);
    }
    return data;
  });
}

function safeParse(text) {
  try { return JSON.parse(text); } catch (_e) { return text; }
}
